<script>
    import VueTypes from "vue-types"

    export default {
        props: {
            type: VueTypes.oneOf(["success", "failure", "error", "info", "warning"]).isRequired,
            message: VueTypes.string.isRequired,
        },
        render(h){
            return null;
        },
        created(){
            this.$toast[this.type](this.message);
        }
    }
</script>